<header id="masthead-black-bar" class="clearfix masthead-black-bar"> 
  <div>
    <nav class="row">
      <ul id="global-nav" class="menu global-nav text-right" data-vf-google-analytics-region="Black bar">
        <li class="float-right show-for-medium embl-selector embl-ebi">
          <a class="button float-right custom-ebi-logo-bg " style="color: transparent; cursor: pointer" href="https://www.ebi.ac.uk">EMBL-EBI</a>
        </li>
        <li class="what about"><a href="https://www.ebi.ac.uk/about">About us</a></li>
        <li class="what training"><a href="https://www.ebi.ac.uk/training">Training</a></li>
        <li class="what research"><a href="https://www.ebi.ac.uk/research">Research</a></li>
        <li class="what services"><a href="https://www.ebi.ac.uk/services">Services</a></li>
        <li class="where ebi"><a href="https://www.ebi.ac.uk">EMBL-EBI home</a></li>
      </ul>
    </nav>
  </div>
</header>
  